import React from "react";
import { getLocalStorageKey } from "utils/utils";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import httpService from "services/http-service";
import { getLocalStorageValue } from "utils/utils";
import { useNavigate, useLocation } from "react-router-dom";
import Sheet from "react-modal-sheet";
import { MdOutlineClose } from "react-icons/md";
import { FaImage, FaCamera,FaInstagram, FaLinkedin, FaGlobe, FaUser, FaCircle } from "react-icons/fa";
import Chip from '@mui/material/Chip';
import ChipList from "components/chiplist/chiplist";
import { industries } from "utils/common";
import Header from "components/header/HeaderAuthDefault";
import { interests } from "utils/common";
import Lottie from "react-lottie";
import confetti from "./confetti.json";


export default function Editprofile() {

    const confettiOptions = {
      loop: true,
      autoplay: true,
      animationData: confetti,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };
  const location = useLocation();
  const [eventName, seteventName] = useState('');
  const userId = getLocalStorageValue("userDetails", "userId");
  const userEmail = getLocalStorageKey("userEmail");
  const userPhoneNumber = getLocalStorageKey("userPhoneNumber");
  const eventId = getLocalStorageKey("eventId");
  const prevName = getLocalStorageValue("userDetails", "userName");
  const [loading, setLoading] = useState(false);
  const [interestType, setInterestType] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [startY, setStartY] = useState(0);
  const [dateError, setDateError] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [firstName, setfirstName] = useState(prevName);
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [instagramUrl, setInstagramUrl] = useState("");
  const [instagramError, setInstagramError] = useState('');
  const [showPhotoPrompt, setShowPhotoPrompt] = useState(false);
  const [activeSocial, setActiveSocial] = useState('instagram');
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [vibe, setvibe] = useState(null);
  const userDetails = {
    ...JSON.parse(localStorage.getItem("userDetails")),
  };

  const handleMouseDown = (event) => {
    setStartY(event.clientY);
  };
  const handleMouseUp = (event) => {
    const deltaY = event.clientY - startY;
    if (deltaY > 50) { // Adjust the threshold as needed
      setIsOpen(false);
    }
  };
  const navigate = useNavigate();

 const handleIndustrySelect = (industry) => {
  setSelectedIndustries(prev => {
    const newSelection = prev.includes(industry)
      ? prev.filter(item => item !== industry)
      : [...prev, industry];
    
    setFormData(prevData => ({
      ...prevData,
      industries: {
        choices: newSelection
      }
    }));
    
    return newSelection;
  });
};
  const handleRouteClick = (page) => {
    navigate(page); // Navigate to specific page
  };

  // useEffect(() => {
  //   if (location.pathname.includes("regular")) {
  //     setIsRegular(true);
  //   } else {
  //     setIsRegular(false);
  //   }
  // }, [location.pathname]);

  const handleClearSelection = () => {
    switch (interestType) {
      case 'Date':
        setSelectedDateItems([]);
        setFormData({
          ...formData,
          date: false
        });
        break;
      case 'Network':
        setSelectedNetworkItems([]);
        setFormData({
          ...formData,
          network: false,
          title: '' 
        });
        break;
      case 'Friends':
        setSelectedFriendshipItems([]);
        setFormData({
          ...formData,
          makeFriends: false
        });
        break;
      default:
        break;
    }    
    setIsOpen(false);
  };



  const handleUpdateProfile = async () => {
    setLoading(true);
    const endpoint = "/bartenders/updateProfile/" + userId;
    const data = {
      firstName: firstName
    };
    const response = await httpService("PUT", endpoint, data);
    if (response.Error === "HttpException") {
      setLoading(false);
      toast.error(response.Message);
    } else {
      setLoading(false);
      localStorage.setItem(
        "userDetails",
        JSON.stringify({ ...userDetails, userName: firstName })
      );
      toast.success(response.message);
    }
  };



  const handleOpenInterest = (interest) => {
    setInterestType(interest);
    setIsOpen(true);
  };
  const [selectedDateItems, setSelectedDateItems] = useState([]);
  const [selectedNetworkItems, setSelectedNetworkItems] = useState([]);
  const [selectedFriendshipItems, setSelectedFriendshipItems] = useState([]);

  const handleNetworkSelect = (selectedChips) => {

    if (selectedChips && selectedChips.length > 0) {
      setSelectedNetworkItems(selectedChips);
      setFormData({
        ...formData,
        network: true
      })
    } else {
      setFormData({
        ...formData,
        network: false
      })
    }
  };

   useEffect(() => {
      getAlEvents();
    }, []);
  
   const getAlEvents = async () => {
  setLoading(true);
  
  if (!eventId) {
    navigate('/auth/home');
    return;
  }
  
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  
  if (!userId) {
    setLoading(false);
    return;
  }

  const endpoint = `/Event/GetEventPeopleForGuestUser/${eventId}?userId=${userId}`;
  const response = await httpService("GET", endpoint);
  if (response.Error === "HttpException") {
    setLoading(false);
    toast.error(response.Message);
  } else {
    updateEventsData(response);
    setLoading(false);
  }
};


  const updateEventsData = (eventData) => {
  seteventName(eventData?.eventName);
  setvibe(eventData?.vibe);
};
    
  const handleFriendshipSelect = (selectedChips) => {

    if (selectedChips && selectedChips.length > 0) {
      setSelectedFriendshipItems(selectedChips);
      setFormData({
        ...formData,
        makeFriends: true
      })
    } else {
      setFormData({
        ...formData,
        makeFriends: false
      })
    }
  };
  const handleDateSelect = (selectedChips) => {
    if (selectedChips && selectedChips.length > 0) {
      setSelectedDateItems(selectedChips);
      setFormData({
        ...formData,
        date: true
      })
    } else {
      setFormData({
        ...formData,
        date: false
      })
    }

  };

  const handlegenderSelect = (genderValue) => {

    setFormData({
      ...formData,
      sex: genderValue[0]
    })
  };

  const [image, setImage] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
        uploadImage(reader.result);
      };
      reader.readAsDataURL(file);

    }
  };

  // Inside your component function
  const [formData, setFormData] = useState({
    firstName: '',
    lastName:'',
    career:'',
    industries: {
    choices: []
  },
    dateOfBirth: '',
    sex: '',
    accountSetupStatus: 'Setup Completed',
    title: '',
    network: false,
    makeFriends: false,
    date: false,
    dateFor: {
      choices: []
    },
    friendLookingFor: {
      choices: []
    },
    industries: {
      choices: []
    },
    networkGoals: {
      choices: []
    },
    linkedIn: '',
    instagram: '',
    website: ''
  });


  const handleCancelChanges = () => {
    // Reset form data here
    setFormData({
      ...formData,
      firstName: '',
      lastName:'',
      career:'',
      industries: {
    choices: []
  },
      dateOfBirth: '',
      sex: '',
      title: '',
      network: false,
      makeFriends: false,
      date: false,
      dateFor: {
        choices: []
      },
      friendLookingFor: {
        choices: []
      },
      industries: {
        choices: []
      },
      networkGoals: {
        choices: []
      },
      linkedIn: '',
      instagram: '',
      website: ''
    });
    // Redirect to edit-profile page
    navigate('/auth/events');
  };

  useEffect(() => {
    // Update Instagram URL whenever the Instagram username changes
    if (formData && formData.instagram) {
      setInstagramUrl(`https://www.instagram.com/${formData.instagram}/`);
    }
  }, [formData]);


  useEffect(() => {
    // Check if the user is redirected from the events page
    if (location.state && location.state.fromEventsPage) {
      setShowCancelButton(true);
    }
  }, [location.state]);


  const validateInstagram = (username) => {
    // Regular expression to validate Instagram username format
    const instagramRegex = /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,28}$/;
    if (username === '') {
      return true;
    }
    return username.length >= 4 && instagramRegex.test(username);
  };


  const validateForm = () => {
    const hasAnySocialMedia = 
      (formData.instagram && formData.instagram.trim() !== '') ||
      (formData.linkedIn && formData.linkedIn.trim() !== '') || 
      (formData.website && formData.website.trim() !== '');
  
    setIsFormValid(hasAnySocialMedia);
    return hasAnySocialMedia;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'instagram') {
      if
        (!validateInstagram(value)) {
        setInstagramError('Please enter a valid Instagram username.');
        // Disable the "Save changes" button if validation fails
        setIsFormValid(false);
      }
      else if (!value) {
        setInstagramError('');
        // Enable the "Save changes" button if validation passes
        setIsFormValid(false);
      }
      else {
        setInstagramError('');
        // Enable the "Save changes" button if validation passes
        setIsFormValid(true);
      }
    }
    if (name === 'linkedIn') {
      if
        (value.includes('https://linkedin.com/') || value.includes('https://wwww.linkedin.com/')) {
        setIsFormValid(true);
      }
      else if (!value) {
        setIsFormValid(false);
      }
    }
    if (name === 'dateOfBirth') {
      const today = new Date();
      const birthDate = new Date(value);
      const age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      if (age < 18) {
        setDateError("You must be at least 18 years old");
      } else {
        setDateError(""); // Clear the error message if age is valid
      }
    }
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const validateSubmitForm = () => {
    formData.dateFor.choices = selectedDateItems;
    formData.friendLookingFor.choices = selectedFriendshipItems;
    formData.networkGoals.choices = selectedNetworkItems;

     if (!formData.firstName) {
      toast.error("Please enter your first name to continue");
      return false;
    }
  
    if (!validateForm()) {
      toast.error("Please enter at least one social media account");
      return false;
    }

    return true;
  };


  const handleSubmit = async () => {
  if (!validateSubmitForm()) return;

  // Check if image is not added
  if (!image) {
    setShowPhotoPrompt(true);
    return;
  }

  // Proceed with submission if image exists
  await submitProfileData();
};

const submitProfileData = async () => {
  setLoading(true);
  
  try {
    let networkFlag = false;
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith('eventData')) {
        const eventData = JSON.parse(sessionStorage.getItem(key) || '{}');
        if (eventData.vibe === "Networking") {
          networkFlag = true;
          break;
        }
      }
    }

    const dataToSend = {
      ...formData,
      network: networkFlag || formData.network 
    };

    const endpoint = `/User/${userId}`;
    const response = await httpService("PUT", endpoint, dataToSend);

    if (response) {
      const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
      userDetails.accountSetupStatus = dataToSend.accountSetupStatus || 'Setup Completed';
      localStorage.setItem('userDetails', JSON.stringify(userDetails));

      setLoading(false);
      navigate('/auth/events');
    } else {
      setLoading(false);
      toast.error(response?.message || 'Error updating profile');
    }
  } catch (error) {
    setLoading(false);
    console.error('Error occurred:', error);
    toast.error('An error occurred while updating the profile');
  }
};

  const uploadImage = async (img) => {
    const postImage = {
      userId: userId,
      userProfileBaseFileDTO: [
        {
          orderId: 1,
          base64: img,
        },
      ],
    };
    setLoading(true);
    const endpoint = `/User/AddUserProfilePhoto`;
    const response = await httpService("POST", endpoint, postImage);
    if (!response) {
      setLoading(false);
      toast.error(response.Message || 'Error uploading profile photos');
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {

    if (!userId) {
      const fetchData = async () => {
        await populateUserData();
        await populateEventData();

      };
      fetchData();

    }
  }, [userId]);
  const populateUserData = async () => {
  setLoading(true);

  try {
    if (!userId) {
      const data = {
        country: '+1',
        phoneNumber: userPhoneNumber,
        email: getLocalStorageKey('userEmail')
      };
      const userResponse = await httpService("POST", "/User", data);

      if (!userResponse) {
        toast.error(userResponse.message || 'Error while registering');
        setLoading(false);
        return;
      } else {
        localStorage.setItem("userDetails", JSON.stringify(userResponse));
        if (userResponse?.token) {
          localStorage.setItem("token", userResponse?.token);
        }
        
        await getAlEvents();
      }
    }
  } catch (error) {
    toast.error('An error occurred while fetching data');
    console.error('Fetch data error:', error);
  } finally {
    setLoading(false);
  }
};
  const populateEventData = async () => {
    setLoading(true);

    try {


      const eventResponse = await httpService("GET", `/Event/${eventId}`);
      if (eventResponse.Error === "HttpException") {
        toast.error(eventResponse.Message);
        setLoading(false);
        return;
      } else {
        updateEventData(eventResponse);
      }

    } catch (error) {
      toast.error('An error occurred while fetching data');
      console.error('Fetch data error:', error);
    } finally {
      setLoading(false);
    }
  };


  const updateEventData = (eventData) => {
    seteventName(eventData?.name);
  };


  return (
    
  <div className="mb-16 pt-0 flex h-full w-full max-w-full justify-center md:mx-0 md:px-0 lg:mb-10 lg:justify-start overflow-x-hidden">
      {/* <Loading loading={loading} loaderColor="#252424" /> */}
    <div className="fixed inset-0 overflow-hidden" style={{ zIndex: 0 }}>
      <Lottie
        style={{
          position: "absolute",
          height: 400,
          zIndex: 0,
          pointerEvents: "none",
        }}
        options={{
          ...confettiOptions,
          loop: false,
          autoplay: true
        }}
        isStopped={false}
        isPaused={false}
      />
    </div>

   <div className="container mx-auto relative z-10">
      <div>
        {loading ? (
          <div className="animate-pulse">
              <div className="flex flex-col items-center mb-[37px] mt-[5px]">
                <div className="h-24 w-24 rounded-full bg-gray-300 mb-4"></div>
                <div className="h-6 w-48 bg-gray-300 rounded mb-2"></div>
              </div>


              <div className="h-10 w-full bg-gray-300 rounded mb-6"></div>

              <div className="mb-4">
                <div className="h-6 w-24 bg-gray-300 rounded mb-2"></div>
                <div className="flex">
                  <div className="h-10 w-28 bg-gray-300 rounded m-2"></div>
                  <div className="h-10 w-36 bg-gray-300 rounded m-2"></div>
                  <div className="h-10 w-40 bg-gray-300 rounded m-2"></div>
                </div>
              </div>
              <div className="mb-4">
                <div className="h-6 w-32 bg-gray-300 rounded mb-2"></div>
                <div className="h-10 w-full bg-gray-300 rounded"></div>
              </div>
              <div className="mb-4">
                <div className="h-6 w-32 bg-gray-300 rounded mb-2"></div>
                <div className="h-10 w-full bg-gray-300 rounded"></div>
              </div>
              <div className="mb-4">

                <div className="w-full rounded-xl bg-gray-300 dark:bg-gray-700 h-10 animate-pulse"></div>
              </div>

            </div>
          ) : (<>
                        <div className="-ml-2 flex flex-col items-start justify-start text-xl font-bold text-navy-700 dark:text-white">
            <Header
          tagline={ 
              "Go out, Find your crowd"
          }
        />
        </div>
              <div className="mt-6 ml-2 flex flex-col items-start justify-start text-xl font-bold text-navy-700 dark:text-white">
                <h4 className=" text-2xl font-bold text-navy-700 dark:text-white">
                  {eventName}
                </h4>
                <p className="mt-1 mb-4 text-base font-normal text-gray-700">
                  Let's get you connected.
                </p>
              </div>
            <div>
          </div>
          
  <div>
 <label className="mb-2 ml-1 flex items-center gap-2 text-base font-semibold text-navy-700 dark:text-white">
  <FaUser className="text-navy-700 dark:text-white" />
  Name
</label>


  <div className="flex gap-4 mb-2">
    <div className="flex-1">
      <input
        id="firstName"
        type="text"
        name="firstName"
        value={formData?.firstName}
        onChange={handleChange}
        className="mt-1 p-2 w-full rounded-md border border-gray-300 shadow-sm focus:outline-none focus:border-brand-500 focus:ring focus:ring-brand-500 focus:ring-opacity-50 dark:bg-gray-800 dark:border-gray-600 dark:text-white"
        placeholder="First name"
      />
    </div>

    {/* {vibe !== "Social" && (
      <div className="flex-1">
        <input
          id="lastName"
          type="text"
          name="lastName"
          value={formData?.lastName}
          onChange={handleChange}
          className="mt-1 p-2 w-full rounded-md border border-gray-300 shadow-sm focus:outline-none focus:border-brand-500 focus:ring focus:ring-brand-500 focus:ring-opacity-50 dark:bg-gray-800 dark:border-gray-600 dark:text-white"
          placeholder="Last name"
        />
      </div>
    )} */}
  </div>
</div>
              {/* <div className="mb-4">
                <label htmlFor="career" className="block text-sm font-medium text-gray-700 dark:text-white">
                  Your career
                </label>
                <input
                  id="career"
                  type="text"
                  name="career"
                  value={formData?.career}
                  onChange={handleChange}
                  className="mt-1 p-2 w-full rounded-md border border-gray-300 shadow-sm focus:outline-none focus:border-brand-500 focus:ring focus:ring-brand-500 focus:ring-opacity-50 dark:bg-gray-800 dark:border-gray-600 dark:text-white"
                  placeholder="Your work title"
                />
              </div> */}
            <div className="flex items-center justify-between px-2">
              <div className="flex items-center"></div>
            </div>
{vibe === "Networking" ? (
  <>
    <div className="mb-4">
   <label className="mb-2 mt-4 ml-1 flex items-center gap-2 text-base font-semibold text-navy-700 dark:text-white">
 <span className="relative inline-block w-4 h-4 text-navy-700">
  <img src="/career-icon.svg" alt="Location Icon" className="absolute w-full h-full" />
</span>

  Your career
</label>
      <input
        id="career"
        type="text"
        name="career"
        value={formData?.career}
        onChange={handleChange}
        className="mt-1 p-2 w-full rounded-md border border-gray-300 shadow-sm focus:outline-none focus:border-brand-500 focus:ring focus:ring-brand-500 focus:ring-opacity-50 dark:bg-gray-800 dark:border-gray-600 dark:text-white"
        placeholder="Your work title"
      />
    </div>
    
    <div className="mb-4">
      <label className="block text-sm ml-1 font-medium text-gray-600 dark:text-white mb-2">
        Your industries of interest
      </label>
      <div className="relative">
        <div
          className="flex space-x-2 pb-2 overflow-x-auto"
          style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {industries.map((industry) => (
            <Chip
              key={industry}
              onClick={() => handleIndustrySelect(industry)}
              label={industry}
              variant={selectedIndustries.includes(industry) ? "filled" : "outlined"}
              className="flex-shrink-0 [&::-webkit-scrollbar]:hidden"
            />
          ))}
        </div>
      </div>
    </div>
  </>
) : (
  <>
    
 {/* {vibe !== "Networking" && (
  <>
    <label className="flex ml-1 items-center gap-2 text-navy-700 text-base font-semibold mt-4">
 <span className="relative inline-block w-4 h-4 text-navy-700">
  <img src="/career-icon.svg" alt="Career Icon" className="absolute w-full h-full" />
</span>
  What brings you here?
</label>

    <label htmlFor="instagram" className="block text-sm font-medium text-gray-600 mb-1 ml-1 mt-1">
    Pick one or more
    </label>

    <div>
      <div className="flex items-center justify-between mb-2">
        <Chip
          onClick={() => handleOpenInterest('Network')}
          label="🤝 Networking"
          variant={formData.network ? "filled" : "outlined"}
          className="m-2"
        />
        <Chip
          onClick={() => handleOpenInterest('Friends')}
          label="🎉 Friendships"
          variant={formData.makeFriends ? "filled" : "outlined"}
          className="m-2"
        />
        <Chip
          onClick={() => handleOpenInterest('Date')}
          label="❤️ Dating"
          variant={formData.date ? "filled" : "outlined"}
          className="m-2"
        />
      </div>
    </div>
  </>
)} */}
  </>
)}
 <label className="mb-2 mt-4 ml-1 flex items-center gap-2 text-base font-semibold text-navy-700 dark:text-white">
 <span className="relative inline-block w-4 h-4 text-navy-700">
  <img src="/double-s.svg" alt="Double S Icon" className="absolute w-full h-full" />
</span>

  Share your socials
</label>
    <label htmlFor="instagram" className="block ml-1 text-sm font-medium text-gray-600 mb-1 mt-1">
      Choose where you want to connect
    </label>
<div className="flex items-center justify-between mb-2 mt-2">
  <Chip
    onClick={() => setActiveSocial(activeSocial === 'instagram' ? null : 'instagram')}
    label="Instagram"
    variant={activeSocial === 'instagram' || formData.instagram ? "filled" : "outlined"}
    className="m-1"
    icon={
    <img
      src="/instagram-icon.svg"
      alt="Instagram"
      className="w-4 h-4 mr-1"
    />}
  />

  <Chip
    onClick={() => setActiveSocial(activeSocial === 'linkedIn' ? null : 'linkedIn')}
    label="LinkedIn"
    variant={activeSocial === 'linkedIn' || formData.linkedIn ? "filled" : "outlined"}
    className="m-1"
    icon={
    <img
      src="/linkedin-icon.svg"
      alt="LinkedIn"
      className="w-4 h-4 mr-1"
    />
  }
  />

  <Chip
  onClick={() => setActiveSocial(activeSocial === 'website' ? null : 'website')}
  label="Website"
  variant={activeSocial === 'website' || formData.website ? "filled" : "outlined"}
  className="m-1"
  icon={
    <img
      src="/website-icon.svg"
      alt="Website"
      className="w-4 h-4 mr-1"
    />
  }
/>

</div>


{(activeSocial === 'instagram' || (!activeSocial && !formData.linkedIn && !formData.website)) && (
  <div className="mb-4 w-full">
    <div className="relative">
      <input
        id="instagram"
        type="text"
        name="instagram"
        value={formData.instagram}
        onChange={handleChange}
        className={`mb-1 mt-1 p-2 px-6 w-full rounded-md border border-gray-300 shadow-sm focus:outline-none focus:border-brand-500 focus:ring focus:ring-brand-500 focus:ring-opacity-50 dark:bg-gray-800 dark:border-gray-600 dark:text-white ${instagramError ? "border-red-500" : ""}`}
        placeholder="Your Instagram handle"
      />
      <div className="absolute inset-y-0 right-0 flex items-center pr-3">
        <FaInstagram className="h-5 w-5 text-gray-400" />
      </div>
    </div>
    {formData.instagram && (
      <a href={'https://instagram.com/' + formData.instagram} target="_blank" className="text-sm-link-blue mt-1" onClick={() => window.open(instagramUrl, '_blank')}>
        Tap to test your Instagram profile link.
      </a>
    )}
    {instagramError && <p className="text-red-500 text-sm mt-1">{instagramError}</p>}
  </div>
)}

{activeSocial === 'linkedIn' && (
  <div className="mb-4 w-full">
    <div className="relative">
      <input
        id="linkedIn"
        type="text"
        name="linkedIn"
        value={formData?.linkedIn}
        onChange={handleChange}
        className="mb-1 mt-1 p-2 px-6 w-full rounded-md border border-gray-300 shadow-sm focus:outline-none focus:border-brand-500 focus:ring focus:ring-brand-500 focus:ring-opacity-50 dark:bg-gray-800 dark:border-gray-600 dark:text-white"
        placeholder="Your LinkedIn (https://linkedin.com/name)"
      />
      <div className="absolute inset-y-0 right-0 flex items-center pr-3">
        <FaLinkedin className="h-5 w-5 text-gray-400" />
      </div>
    </div>
    {formData.linkedIn && (
      <a href={formData.linkedIn} target="_blank" className="text-sm-link-blue mt-1" onClick={() => window.open(formData.linkedIn, '_blank')}>
        Tap to test your LinkedIn profile link.
      </a>
    )}
  </div>
)}

{activeSocial === 'website' && (
  <div className="mb-4 w-full">
    <div className="relative">
      <input
        id="website"
        type="text"
        name="website"
        value={formData?.website}
        onChange={handleChange}
        className="mb-1 mt-1 p-2 px-6 w-full rounded-md border border-gray-300 shadow-sm focus:outline-none focus:border-brand-500 focus:ring focus:ring-brand-500 focus:ring-opacity-50 dark:bg-gray-800 dark:border-gray-600 dark:text-white"
        placeholder="Your website (https://example.com)"
      />
      <div className="absolute inset-y-0 right-0 flex items-center pr-3">
        <FaGlobe className="h-5 w-5 text-gray-400" />
      </div>
    </div>
    {formData.website && (
      <a 
        href={formData.website.startsWith('http') ? formData.website : `https://${formData.website}`} 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-sm-link-blue mt-1"
      >
        Tap to test your website link
      </a>
    )}
  </div>
)}
            <button
              onClick={handleSubmit}
              disabled={!(validateForm)}
              className={`linear w-full rounded-xl py-[12px] text-base font-medium text-white duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 ${formData.firstName && ((validateInstagram(formData.instagram) && !instagramError) || (formData.linkedIn.includes('https://linkedin.com/') || (formData.linkedIn.includes('https://wwww.linkedin.com/')))) ? 'bg-brand-500' : 'bg-gray-400'}`}
            >
              Check-in with a photo
            </button>
<p className="text-sm font-semibold text-brand-500 mt-4 mb-10 text-center">
  Step 2 of 2
</p>

            {showCancelButton && (
              <button onClick={handleCancelChanges} className="linear mt-3 w-full rounded-xl bg-gray-300 py-[12px] text-base font-medium text-gray-700 duration-200 hover:bg-gray-400 active:bg-gray-500 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 dark:active:bg-gray-800">
                Cancel Changes
              </button>)}
          </>)}

        </div>

{/* Photo Prompt Sheet */}
<Sheet isOpen={showPhotoPrompt} onClose={() => setShowPhotoPrompt(false)}>
  <Sheet.Container className="custom-sheet-container">
    <Sheet.Header>
      <div className="flex justify-between items-center w-full p-4">
        <h2 className="text-xl font-bold">Complete Your Profile</h2>
        <button onClick={() => setShowPhotoPrompt(false)} className="text-gray-700 dark:text-white">
          <MdOutlineClose className="h-6 w-6" />
        </button>
      </div>
    </Sheet.Header>
    
    <Sheet.Content className="p-6">
      <div className="text-center mb-6">
        <div className="flex justify-center mb-4">
          {image ? (
            <div className="relative">
              <img
                src={image}
                alt="Profile Preview"
                className="rounded-full h-32 w-32 object-cover border-4 border-brand-500"
              />
              <label 
                htmlFor="reupload"
                className="absolute bottom-0 right-0 bg-white dark:bg-gray-700 p-2 rounded-full shadow-md cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600"
              >
                <FaCamera className="text-brand-500" />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    handleImageChange(e);
                    submitProfileData(); 
                  }}
                  className="hidden"
                  id="reupload"
                />
              </label>
            </div>
          ) : (
            <div className="rounded-full bg-gray-200 dark:bg-gray-700 h-32 w-32 flex items-center justify-center">
              <FaImage className="text-4xl text-brand-500 dark:text-white" />
            </div>
          )}
        </div>
        <h3 className="text-lg font-bold mb-2">
          {image ? "Profile photo uploaded!" : "Add a profile photo"}
        </h3>
        <p className="text-gray-600 dark:text-gray-300">
          {image 
            ? "Your profile is being saved..." 
            : "Adding a photo helps others recognize you and increases your chances of making connections."}
        </p>
      </div>
      
      <div className="space-y-3">
        {!image ? (
          <>
            <label
              htmlFor="upload"
              className="linear block w-full rounded-xl bg-brand-500 py-3 text-base font-medium text-white hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 text-center cursor-pointer"
            >
              Upload Photo
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  handleImageChange(e);
                  submitProfileData(); // Auto-submit when image is selected
                }}
                className="hidden"
                id="upload"
              />
            </label>
            
            {/* <button
              onClick={() => {
                setShowPhotoPrompt(false);
                submitProfileData();
              }}
              className="w-full rounded-xl py-3 text-base font-medium transition-colors duration-200
                bg-blue-50 text-blue-700 hover:bg-blue-100 active:bg-blue-200
                dark:bg-blue-900/20 dark:text-blue-200 dark:hover:bg-blue-900/30 dark:active:bg-blue-900/40"
            >
              Skip for Now
            </button> */}
          </>
        ) : null}
      </div>
    </Sheet.Content>
  </Sheet.Container>
  <Sheet.Backdrop />
</Sheet>

        <Sheet isOpen={isOpen} onClose={() => setIsOpen(false)}>
          <Sheet.Container className="custom-sheet-container">
            <Sheet.Header onMouseDown={handleMouseDown} onMouseUp={handleMouseUp}>
              <div className="drag-handle mt-10" onMouseDown={handleMouseDown} />
              <div className="flex justify-between items-center w-full"> {/* Wrap elements in a flex container */}
                <h2 className="ml-5 mt-5"><b>{'Tell us about you'}</b></h2>
                <button onClick={() => setIsOpen(false)} className="text-gray-700 dark:text-white mr-3 mb-5">
                  <MdOutlineClose className="h-6 w-6" />
                </button>
              </div>
            </Sheet.Header>

            <Sheet.Content className="overflow-y-scroll pb-8 h-[70vh]"> {/* Apply overflow-y-scroll class */}
              <div className="h-full overflow-y-auto hide-scrollbar">
                <div className="sheet-inner-content">
                  {interestType === 'Date' && <div className="p-4">

                    {/* <div className="mb-4">
                      <label htmlFor="interest" className="block text-sm font-medium text-gray-700 mb-1">
                        You're Interested in dating a...
                      </label>
                      <ChipList
                        items={genders} // Replace with the list of interests
                        allowMultipleSelection={true}
                        onSelect={handleDateSelect}
                      />
                    </div> */}

                    <div className="mb-28">
                      <label htmlFor="interests" className="block text-sm font-medium text-gray-700 mb-1">
                        Your interests
                      </label>
                      <ChipList
                        items={interests}
                        allowMultipleSelection={true}
                        onSelect={handleDateSelect}
                      />
                    </div>

                    {/* Other sections go here */}
                  </div>}
                  {interestType === 'Network' && <div className="p-4">
                    <div className="mb-4">
                      <label htmlFor="gender" className="block text-sm font-medium text-gray-700 mb-1">
                        Your career
                      </label>
                      <input
                        autoFocus
                        className="dark:text-black mt-4 flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 p-3 text-sm outline-none dark:!border-white/10"
                        placeholder="Your work title"
                        inputMode="text"
                        id="title"
                        name="title"
                        type="text"
                        value={formData.title}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-4">
                      <label htmlFor="gender" className="block text-sm font-medium text-gray-700 mb-1">
                        Your industries of interest
                      </label>
                      <ChipList
                        items={industries}
                        allowMultipleSelection={true}
                        onSelect={handleNetworkSelect}
                      />
                    </div>

                  </div>}

                  {interestType === 'Friends' && <div className="p-4">

                    <div className="mb-4">
                      <label htmlFor="interests" className="block text-sm font-medium text-gray-700 mb-1">
                        Your interests
                      </label>
                      <ChipList
                        items={interests}
                        allowMultipleSelection={true}
                        onSelect={handleFriendshipSelect}
                      />
                    </div>
                  </div>}
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                  <div className="sticky-bottom -mb-4 w-full blurry-background">
                    <div className="p-2">
                      <button onClick={() => setIsOpen(false)} className="linear w-full  rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                        Save changes
                      </button>
                    </div>
                    <div className="mb-4 p-2">
                      <button onClick={handleClearSelection} className="linear w-full rounded-xl bg-gray-300 py-[12px] text-base font-medium text-black duration-200 hover:bg-gray-400 active:bg-gray-500 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600 dark:active:bg-gray-800">
                        Clear My Selection
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Sheet.Content>
          </Sheet.Container>
          <Sheet.Backdrop />
        </Sheet>
      </div>
    </div>
  );
}

